var React = require('react');

function SaveIcon (props) {
    return React.createElement("svg",props,[React.createElement("filter",{"id":"dropshadow","x":"-2","y":"-2","width":"200","height":"200","key":0},React.createElement("feGaussianBlur",{"stdDeviation":"1"})),React.createElement("path",{"d":"M256.91,335l191,154.43a1.46,1.46,0,0,0,2.37-1.11V23.68a1.44,1.44,0,0,0-1.46-1.42H63.18a1.44,1.44,0,0,0-1.46,1.42V488.31a1.46,1.46,0,0,0,2.37,1.11L255.09,335A1.45,1.45,0,0,1,256.91,335Z","key":1}),React.createElement("path",{"className":"blur","d":"M256.91,335l191,154.43a1.46,1.46,0,0,0,2.37-1.11V23.68a1.44,1.44,0,0,0-1.46-1.42H63.18a1.44,1.44,0,0,0-1.46,1.42V488.31a1.46,1.46,0,0,0,2.37,1.11L255.09,335A1.45,1.45,0,0,1,256.91,335Z","key":2})]);
}

SaveIcon.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = SaveIcon;

SaveIcon.default = SaveIcon;
